module.exports = __webpack_public_path__ + "media/limitations/molduras_el-8aef61a1.png";